/**
 * DownloadCounter Module - Following guidelines
 * Pure Tailwind, no inline styles, array mapping
 */

import { debugLog } from '../debug/logger.js'

class DownloadCounter {
	constructor() {
		// Configuration using arrays
		this.CONFIG = {
			SELECTORS: {
				checkbox: '.list--downloads input[type="checkbox"], input[type="checkbox"][name="downloads"], input[type="checkbox"][name="downloads[]"], input[type="checkbox"][name$="[downloads][]"]',
				counter: '[data-download-count], .downloads--number',
				form: '.ui-dl-form',
			},
		}

		// Get elements
		this.elements = this.getElements()

		// Initialize
		this.init()
	}

	getElements() {
		const { SELECTORS } = this.CONFIG
		return {
			checkboxes: document.querySelectorAll(SELECTORS.checkbox),
			counter: document.querySelector(SELECTORS.counter),
			form: document.querySelector(SELECTORS.form) || document.querySelector('#DownloadForm'),
		}
	}

	init() {
		// Bind events
		this.bindEvents()

		// Initial count
		this.updateCounter()

		debugLog.success('DownloadCounter: Initialized with', this.elements.checkboxes.length, 'checkboxes')
	}

	bindEvents() {
		const updateCounter = () => {
			window.requestAnimationFrame(() => this.updateCounter())
		}

		if (this.elements.form) {
			this.elements.form.addEventListener('change', event => {
				if (event.target instanceof HTMLInputElement && event.target.matches(this.CONFIG.SELECTORS.checkbox)) {
					updateCounter()
				}
			})
			return
		}

		document.addEventListener('change', event => {
			if (event.target instanceof HTMLInputElement && event.target.matches(this.CONFIG.SELECTORS.checkbox)) {
				updateCounter()
			}
		})
	}

	updateCounter() {
		const checkedCount = new Set(
			Array.from(document.querySelectorAll(this.CONFIG.SELECTORS.checkbox))
				.filter(checkbox => checkbox instanceof HTMLInputElement && checkbox.checked)
				.map(checkbox => checkbox.id || checkbox.value || checkbox.name)
		).size

		document.querySelectorAll(this.CONFIG.SELECTORS.counter).forEach(counter => {
			counter.textContent = checkedCount
		})

		debugLog.log('DownloadCounter: Updated count to', checkedCount)
	}
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => new DownloadCounter())
} else {
	new DownloadCounter()
}

// Export for use
window.DownloadCounter = DownloadCounter
